
$(document).ready(function () {
  console.log("custom.js loaded");

  var checkifopen = false;
  var checkifopen2 = false;

  // Create a function to update the URL with matchingValues for filter.p.tag
  function updateURL(currentURL, matchingValues, matchingValues2, rangefromValue1, rangetoValue1, rangefromValue2, rangetoValue2) {
    var url = new URL(currentURL);
    rangefromValue1 = parseInt(rangefromValue1);
    rangetoValue1 = parseInt(rangetoValue1);
    rangefromValue2 = parseInt(rangefromValue2);
    rangetoValue2 = parseInt(rangetoValue2);
    // Remove existing filter.p.m.max.cbd parameters
    url.searchParams.delete('filter.p.m.max.cbd');
    url.searchParams.delete('filter.p.m.max.thc');

    console.log("matchingValues", matchingValues)
    if ((rangetoValue1 - rangefromValue1) !== 100) {
      // Add matchingValues for filter.p.tag
      matchingValues.forEach(function (value) {
        url.searchParams.append('filter.p.m.max.thc', value);
      });
    }
    console.log("matchingValues2", matchingValues2)
    if (matchingValues2.length > 1) {
      if ((rangetoValue2 - rangefromValue2) !== 100) {
        // Add matchingValues for filter.p.tag
        matchingValues2.forEach(function (value) {
          if (value > 0) {
            url.searchParams.append('filter.p.m.max.cbd', value);
          }

        });
      }
    } else {
      if (matchingValues.length == 0 && matchingValues2[0] == 0.0) {

        url.searchParams.append('filter.p.m.max.cbd', 0.1);
      }
    }
    // Remove existing filter.v.thcrange and filter.v.cbdrange parameters
    url.searchParams.delete('filter.v.thcrange');
    url.searchParams.delete('filter.v.cbdrange');
    url.searchParams.delete('filter.v.cbdrange');

    console.log(url.toString());
    console.log('vikas' + rangefromValue2);
    console.log('vikas' + rangetoValue2);

    // Add the new filter.v.thcrange and filter.v.cbdrange parameters

    url.searchParams.append('filter.v.thcrange', rangefromValue1 + '-' + rangetoValue1);


    url.searchParams.append('filter.v.cbdrange', rangefromValue2 + '-' + rangetoValue2);


    return url.toString();
  }


  function rangechange() {

    var currentURL = window.location.href;

    // Define default values
    var rangefromValue1 = document.getElementById('thc-min-input').value; // Default "from" value for THC
    var rangetoValue1 = document.getElementById('thc-max-input').value;;  // Default "to" value for THC
    var rangefromValue2 = document.getElementById('cbd-min-input').value; // Default "from" value for CBD
    var rangetoValue2 = document.getElementById('cbd-max-input').value;;  // Default "to" value for CBD


    // Now, rangefromValue1, rangetoValue1, rangefromValue2, and rangetoValue2 are set to the default values unless they are provided in the URL parameters


    // Create an array to collect matching checkbox values for both filter-sublists
    var matchingValues = [];

    // Create an array to collect matching checkbox values
    var matchingValues2 = [];

    // Use jQuery to select checkboxes and collect the checkbox values
    $('.thc-range input[type="checkbox"]').each(function () {
      var label = $(this).next('label');
      var labelText = label.contents().filter(function () {
        return this.nodeType == 3; // Select text nodes
      }).text().trim(); // Trim leading and trailing spaces
      var numericRange = labelText.replace(/[%:]/g, ''); // Remove % and :

      if (numericRange) {
        // Split the range by "to" to check if it's a valid range
        var rangeValues = numericRange.split(' to ');

        if (rangeValues.length === 2) {
          var from = parseInt(rangeValues[0]);
          var to = parseInt(rangeValues[1]);

          if (!isNaN(from) && !isNaN(to) && ((from >= rangefromValue1 && from <= rangetoValue1) || (to >= rangefromValue1 && to <= rangetoValue1))) {
            // Check if the value is not already in the array
            if (matchingValues.indexOf($(this).val()) === -1) {
              matchingValues.push($(this).val());
            }
          }
        } else {
          // Handle the case of single values (e.g., "0% to 5%")
          var value = parseInt(numericRange);

          if (!isNaN(value) && value >= rangefromValue1 && value <= rangetoValue1) {
            // Check if the value is not already in the array
            if (matchingValues.indexOf($(this).val()) === -1) {
              matchingValues.push($(this).val());
            }
          }
        }
      }
    });

    // Use jQuery to select checkboxes and collect the checkbox values
    $('.cbd-range input[type="checkbox"]').each(function () {
      var label = $(this).next('label');
      var labelText = label.contents().filter(function () {
        return this.nodeType == 3; // Select text nodes
      }).text().trim(); // Trim leading and trailing spaces
      var numericRange = labelText.replace(/[%:]/g, ''); // Remove % and :

      if (numericRange) {
        // Split the range by "to" to check if it's a valid range
        var rangeValues = numericRange.split(' to ');
        console.log(rangeValues);
        if (rangeValues.length === 2) {
          var from = parseInt(rangeValues[0]);
          var to = parseInt(rangeValues[1]);

          if (!isNaN(from) && !isNaN(to) && ((from >= rangefromValue2 && from <= rangetoValue2) || (to >= rangefromValue2 && to <= rangetoValue2))) {
            // Check if the value is not already in the array
            if (matchingValues2.indexOf($(this).val()) === -1) {
              matchingValues2.push($(this).val());
            }
          }
        } else {
          // Handle the case of single values (e.g., "0% to 5%")
          var value = parseInt(numericRange);
          if (!isNaN(value) && value >= rangefromValue2 && value <= rangetoValue2) {
            // Check if the value is not already in the array
            if (matchingValues2.indexOf($(this).val()) === -1) {
              matchingValues2.push($(this).val());
            }
          }
        }
      }
    });

    // Update the URL
    var updatedURL = updateURL(currentURL, matchingValues, matchingValues2, rangefromValue1, rangetoValue1, rangefromValue2, rangetoValue2);

    console.log(updatedURL);
    // if (!updatedURL.includes('filter.v.thcrange')) {
    //   console.log('rangetoValue1'+rangetoValue1);
    //   updatedURL += '&filter.v.thcrange=' + rangefromValue1 + '-' + rangetoValue1;
    // }

    // if (!updatedURL.includes('filter.v.cbdrange')) {
    //   console.log('test'+rangetoValue2);
    //   updatedURL += '&filter.v.cbdrange=' + rangefromValue2 + '-' + rangetoValue2;
    // }

    console.log('Updated URL:', updatedURL);

    // Redirect to the updated URL
    window.location.href = updatedURL;
  }

  var hasPotency = false; // Variable to track if "Potency" has been found
  $('.filter-header.h5').on('click', function () {
    if ($(this).text().includes('Potency') && !hasPotency) {

      var currentURL = window.location.href;

      // Define default values
      var rangefromValue1 = document.getElementById('thc-min-input').value; // Default "from" value for THC
      var rangetoValue1 = document.getElementById('thc-max-input').value;;  // Default "to" value for THC
      var rangefromValue2 = document.getElementById('cbd-min-input').value; // Default "from" value for CBD
      var rangetoValue2 = document.getElementById('cbd-max-input').value;;  // Default "to" value for CBD

      // Get the values from the URL parameters
      var thcRangeValue = getQueryParamValue(currentURL, 'filter.v.thcrange');
      var cbdRangeValue = getQueryParamValue(currentURL, 'filter.v.cbdrange');

      // Function to get the value of a query parameter from the URL
      function getQueryParamValue(url, paramName) {
        var params = new URLSearchParams(url.split('?')[1]);
        return params.get(paramName);
      }

      // Check if the parameters exist and parse their values
      if (thcRangeValue) {
        var thcValues = thcRangeValue.split('-');
        if (thcValues.length === 2) {
          rangefromValue1 = parseInt(thcValues[0]);
          rangetoValue1 = parseInt(thcValues[1]);
        }
      }

      if (cbdRangeValue) {
        var cbdValues = cbdRangeValue.split('-');
        if (cbdValues.length === 2) {
          rangefromValue2 = parseInt(cbdValues[0]);
          rangetoValue2 = parseInt(cbdValues[1]);
        }
      }

      var thcSlider = new rSlider({
        target: '#thc-slider',
        values: { min: 0, max: 100 },
        step: 1,
        range: true,
        set: [rangefromValue1, rangetoValue1],
        scale: false,
        labels: false,
        onChange: function (vals) {
          document.getElementById("thc-min-input").value = vals.split(",")[0];
          document.getElementById("thc-max-input").value = vals.split(",")[1];
          if (checkifopen) {
            rangechange();
          }
          checkifopen = true;

        }
      });

      // Event listener for #thc-min-input and #thc-max-input changes
      $('#thc-min-input, #thc-max-input').change(function () {
        rangechange();
      });


      var cbdSlider = new rSlider({
        target: '#cbd-slider',
        values: { min: 0, max: 100 },
        step: 1,
        range: true,
        set: [rangefromValue2, rangetoValue2],
        scale: false,
        labels: false,
        onChange: function (vals) {
          document.getElementById("cbd-min-input").value = vals.split(",")[0];
          document.getElementById("cbd-max-input").value = vals.split(",")[1];
          if (checkifopen2) {
            rangechange();
          }
          checkifopen2 = true;
        }
      });

      // Event listener for #cbd-min-input and #cbd-max-input changes
      $('#cbd-min-input, #cbd-max-input').change(function () {
        rangechange();
      });



      hasPotency = true; // Set the variable to true to indicate it has been found
    } else {
      console.log('Potency is not present in the div');
    }
  });



})